<mbsc-popup
  [options]="popupOptions"
  [anchor]="popupAnchorTemplateFilter"
  [buttons]="popupButtonsTemplateFilter"
  #templateFilterPopup
>

<div class="mbsc-form-group">
    <div class="mbsc-form-group-title"></div>
    <mbsc-switch
  label="Nur meine Vorlagen anzeigen"
  [(ngModel)]="onlyMyTemplates"
  (ngModelChange)="applyTemplateFilter()"
></mbsc-switch>

<div class="mbsc-form-group-title">Benutzer</div>
         <mbsc-select
          [(ngModel)]="selectedIds"   
          [data]="user"
          display="anchored"
          [itemHeight]="50"
          [selectMultiple]="true"
          label="Benutzer"
          labelStyle="stacked"
          inputStyle="box"
          placeholder="Benutzer auswählen"
          (ngModelChange)="applyTemplateFilter()">
        </mbsc-select>

        <div class="mbsc-form-group-title">Titel</div>
    <mbsc-input
      [(ngModel)]="searchTitle"
      placeholder="Titel suchen"
      (ngModelChange)="applyTemplateFilter()"
    ></mbsc-input>

    <div class="mbsc-form-group-title">Ort</div>
    <mbsc-input
      [(ngModel)]="searchLocation"
      placeholder="Ort suchen"
      (ngModelChange)="applyTemplateFilter()"
    ></mbsc-input>

    <div class="mbsc-form-group-title">Status</div>
    <mbsc-select
      [data]="statusData"
      labelStyle="stacked"
      inputStyle="box"
      placeholder="Status"
      label="Status"
      [(ngModel)]="searchStatus"
      [selectMultiple]="true"
      (ngModelChange)="applyTemplateFilter()"
    ></mbsc-select>

    <div class="mbsc-form-group-title">Kategorie</div>
    <mbsc-select
      [data]="categoryData"
      labelStyle="stacked"
      inputStyle="box"
      placeholder="Kategorie"
      label="Kategorie"
      [(ngModel)]="searchCategory"
      [selectMultiple]="true"
      (ngModelChange)="applyTemplateFilter()"
    ></mbsc-select>

    <div class="mbsc-form-group-title">Einsatzzeit</div>
    <mbsc-select
      [data]="operatingTimeData"
      labelStyle="stacked"
      inputStyle="box"
      placeholder="Einsatzzeit"
      label="Einsatzzeit"
      [(ngModel)]="searchOperatingTime"
      [selectMultiple]="true"
      (ngModelChange)="applyTemplateFilter()"
    ></mbsc-select>

    <div class="mbsc-form-group-title">Termin Typ</div>
    <mbsc-select
      [data]="taskType"
      labelStyle="stacked"
      inputStyle="box"
      placeholder="Termin Typ"
      label="Termin Typ"
      [(ngModel)]="searchTaskType"
      [selectMultiple]="true"
      (ngModelChange)="applyTemplateFilter()"
    ></mbsc-select>

    <div class="mbsc-form-group-title">Online Termin</div>
    <mbsc-switch
      label="Online Termin"
      [(ngModel)]="searchOnline"
      (ngModelChange)="applyTemplateFilter()"
    ></mbsc-switch>

    <div class="mbsc-form-group-title">Startzeit</div>
    <mbsc-datepicker
      [controls]="['time']"
      [(ngModel)]="searchStartTime"
      (ngModelChange)="applyTemplateFilter()"
    ></mbsc-datepicker>

    <div class="mbsc-form-group-title">Endzeit</div>
    <mbsc-datepicker
      [controls]="['time']"
      [(ngModel)]="searchEndTime"
      (ngModelChange)="applyTemplateFilter()"
    ></mbsc-datepicker>

    <div class="mbsc-form-group-title">maximale Terminlänge</div>
    <div class="duration-slider-container">
      <ngx-slider
        [(value)]="minDuration"
        [(highValue)]="maxDuration"
        [options]="sliderOptions"
        (userChangeEnd)="applyTemplateFilter()"
      ></ngx-slider>
    </div>
  </div>
</mbsc-popup>
